import styled from 'styled-components';
import { rem } from 'polished';

export const StyledTechTable = styled.div`
  width: 100%;
  .filters {
    display: flex;
    padding: ${rem(`12px`)};
    flex-wrap: wrap;
    background-color: ${({ theme }) => theme.colors.blue_1_65};
    border-radius: ${rem(`12px`)};
    margin-bottom: ${rem(`24px`)};
    ${({ theme }) => theme.breakpoints.tablet`
    `}
    ${({ theme }) => theme.breakpoints.desktop`
      margin-bottom: 0;
    `}
  }
  .filters__head {
    flex: 1 0 auto;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .filters__heading {
    display: flex;
    align-items: center;
    color: ${({ theme }) => theme.colors.yellow_1};
  }
  .filters__buttons {
    display: flex;
    align-items: center;
  }
  .filters__title {
    margin-right: ${rem(`12px`)};
    margin-left: ${rem(`6px`)};
  }
  .filters__items {
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
    align-items: center;
    margin-top: ${rem(`6px`)};
    transition: max-height 300ms ease-in-out;
    overflow: hidden;
  }
  .filters__items--open {
    max-height: ${rem(`600px`)};
  }
  .filters__items--close {
    max-height: 0px;
  }
  .filter__item {
    display: flex;
    margin-right: ${rem(`4px`)};
    margin-bottom: ${rem(`4px`)};
  }
  .list {
    display: grid;
    grid-auto-columns: max-content;
    grid-auto-flow: dense;
    grid-template-columns: repeat(1, 1fr);
    margin: ${rem(`24px`)} ${rem(`-6px`)};
    ${({ theme }) => theme.breakpoints.phablet`
      margin: ${rem(`24px`)} ${rem(`-6px`)};
      grid-template-columns: repeat(2, 1fr);
    `}
    ${({ theme }) => theme.breakpoints.tablet`
      margin: ${rem(`24px`)} ${rem(`-6px`)};
      grid-template-columns: repeat(3, 1fr);
    `}
    ${({ theme }) => theme.breakpoints.desktop`
      margin: ${rem(`24px`)} ${rem(`-12px`)};
      grid-template-columns: repeat(4, 1fr);
    `}
  }
`;
